import React, { useState } from 'react';
import './App.css';

const API_URL = process.env.REACT_APP_API_URL + '/login';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const res = await fetch(API_URL, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'include', // Include cookies pentru sesiuni
        body: JSON.stringify({ email, password })
      });
      
      const data = await res.json();
      
      if (!res.ok) {
        throw new Error(data.message || 'Authentication error!');
      }
      
      if (data.success) {
        // Salvează utilizatorul cu numele complet
        const user = data.user;
        user.fullName = `${user.first_name} ${user.last_name}`;
        
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('isAuthenticated', 'true');
        
        if (onLogin) onLogin();
      } else {
        throw new Error(data.message || 'Authentication error!');
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <form onSubmit={handleSubmit} className="auth-form">
        <h2 className="auth-title">Login</h2>
        
        <input 
          type="email" 
          placeholder="Email" 
          value={email} 
          onChange={e => setEmail(e.target.value)} 
          required 
          className="auth-input"
        />
        
        <input 
          type="password" 
          placeholder="Password" 
          value={password} 
          onChange={e => setPassword(e.target.value)} 
          required 
          className="auth-input"
        />
        
        {error && <div className="auth-error">{error}</div>}
        
        <button 
          type="submit" 
          disabled={loading} 
          className={`auth-button ${loading ? 'loading' : ''}`}
        >
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
        
      </form>
    </div>
  );
} 